import { utcToZonedTime } from 'date-fns-tz';

export function fromUTC(date: string): Date {
  return utcToZonedTime(date, 'UTC');
}
